// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"bf396037","161":"7dc7ce0b","239":"617c29ad","455":"81ab2824","488":"78de2f7e","502":"b9f16ddb","683":"6c64da6e","782":"61f36bad","822":"e546a95e"}[chunkId] + ".chunk.js";
};